/**
 * PC_TD_05,PC_TD_18,PC_TD_25,PC_TD_34
 * importing client
 */
import { clientOff, DirectoryClient as client, CentcomClient,DirectoryClient2 as client2 } from './client';
import { employeeDirectoryConstant } from '../constant';
// apiIndex is offdoarding
import { apiIndex } from '../constant';

/**
 * PC_TG_06
 * @param {*} loadGridPostData has the data to retrieve the data from the db
 * @returns the response
 */

export const getEmployeeDetails = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeDetails,
        payload: loadGridPostData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} countryData PC_ADF_07 has the data to retrieve the data from the db
 * @returns the response
 */
export const getCountry = async (countryData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getCountry,
        payload: countryData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} stateData PC_ADF_07 has the data to retrieve the data from the db
 * @returns the response
 */
export const getState = async (stateData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getState,
        payload: stateData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_ADF_16,PC_ADF_36 has the data to retrieve the data from the db
 * @returns the response
 */
export const postEmployeeAddress = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeAddress,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_ADF_27 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeAddress = async (empData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeAddress,
        payload: empData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} bankData  PC_BDF_06  has the data to retrieve the data from the db
 * @returns the response
 */
export const getBankName = async (bankData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getBankName,
        payload: bankData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} bankData  PC_BDF_06  has the data to retrieve the data from the db
 * @returns the response
 */

export const getAccountType = async (bankData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getAccountType,
        payload: bankData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_BDF_15 has the data to post the data into the db
 * @returns the response
 */
export const postEmployeeBankInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeBankInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} bankData PC_BDF_24 has the data to retrieve the data from the db
 * @returns the response
 */
export const postUploadFile = async (formData) => {
    try {
        const response = await client2(formData)
        return response;
    }catch(error){
        console.error("Error in uploadObject:", error);
        throw error;
    }
};
export const getEmployeeBankInfo = async (bankData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeBankInfo,
        payload: bankData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_EDF_06 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEducationQualification = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEducationQualification,
        payload: loadGridPostData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_EDF_06 has the data to retrieve the data from the db
 * @returns the response
 */
export const getFieldOfStudy = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getFieldOfStudy,
        payload: loadGridPostData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} educationPostData PC_EDF_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const postEmployeeEducationInfo = async (educationPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeEducationInfo,
        payload: educationPostData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} educationData PC_EDF_24 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeEducationInfo = async (educationData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeEducationInfo,
        payload: educationData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_CDF_16 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeCertificateInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeCertificateInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_CDF_07,PC_CDF_25 has the data to retrieve the data from the db
 * @returns the response
 */
export const postEmployeeCertificateInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeCertificateInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeAddressForGrid = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeAddressForGrid,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeBankInfoForGrid = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeBankInfoForGrid,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeEducationInfoForGrid = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeEducationInfoForGrid,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

export const getPlaceOfissue = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getPlaceOfissue,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

export const getEmployeePassportInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeePassportInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

export const PostEmployeePassportInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.PostEmployeePassportInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

export const getEmployeePreviousEmploymentInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeePreviousEmploymentInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

export const postEmployeePreviousEmploymentInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeePreviousEmploymentInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_SF_08 has the data to retrieve the data from the db
 * @returns the response
 */
export const postEmployeeSkillInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeSkillInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_EIF_17 has the data to retrieve the data from the db
 * @returns the response
 */
export const postEmployeePrimaryInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeePrimaryInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_PC_06,PC_EIF_08 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeePrimaryInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeePrimaryInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_EIF_08 has the data to retrieve the data from the db
 * @returns the response
 */
export const getMaritalStatus = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getMaritalStatus,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_EIF_08 has the data to retrieve the data from the db
 * @returns the response
 */
export const getHrList = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getHrList,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeCertificateInfoForGrid = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeCertificateInfoForGrid,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeePassportInfoForGrid = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeePassportInfoForGrid,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeePreviousEmploymentInfoForGrid = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeePreviousEmploymentInfoForGrid,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeSkillInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeSkillInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_P_38 has the data to retrieve the data from the db
 * @returns the response
 */
export const deleteSkillInfo = async (loadGridPostData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.deleteSkillInfo,
        payload: loadGridPostData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} ProfileCoverdata PC_PC_06 has the data to retrieve the data from the db
 * @returns the response
 */
export const getProfileAndCoverImage = async (ProfileCoverdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getProfileAndCoverImage,
        payload: ProfileCoverdata,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} SalaryRevisiondata PC_SRG_06.1 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeSalaryRevisionInfo = async (SalaryRevisiondata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeSalaryRevisionInfo,
        payload: SalaryRevisiondata,
    };
    const response = await client(body);
    return response;
};

export const getNationality = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getNationality,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

export const getRelationship = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getRelationship,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

export const getInsuranceType = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getInsuranceType,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

export const postEmployeeDependentInfo = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeDependentInfo,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_SRG_17 has the data to retrieve the data from the db
 * @returns the response
 */

//PC_SR_25-39 -> Api call is made and response is returned

export const postEmployeeSalaryRevisionInfo = async (SalaryRevisiondata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeSalaryRevisionInfo,
        payload: SalaryRevisiondata,
    };
    const response = await client(body);

    return response;
};

export const getEmployeeSalaryRevisionInfoForm = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeSalaryRevisionInfoForm,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};
export const getS3url = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getS3url,
        payload: Feedbackdata,
    };
    const response = await client(body);
 
    return response;
};

/**
 * PC_PC_06 has the data to retrieve the data
 * from the db and it will return the response
 */

export const getEmployeeDependentInfo = async (Dependentdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeDependentInfo,
        payload: Dependentdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Domaindata PC_TD_03.2.1,PC_FG_06.1 has the data to retrieve the data from the db
 * @returns the response
 */
export const getDomain = async (Domaindata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getDomain,
        payload: Domaindata,
    };

    const response = await client(body);

    return response;
};

export const getEmployeeDependentInfoForForm = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeDependentInfoForForm,
        payload: Feedbackdata,
    };
    //
    const response = await client(body);

    return response;
};

export const getCurrentEvaluationPeriod = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getCurrentEvaluationPeriod,
        payload: Feedbackdata,
    };
    //
    const response = await client(body);

    return response;
};

export const PostEmployeeVisaInfo = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.PostEmployeeVisaInfo,
        payload: Feedbackdata,
    };
    //
    const response = await client(body);

    return response;
};

export const getEmployeeVisaInfo = async (VisaData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeVisaInfo,
        payload: VisaData,
    };
    //
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} VisaData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeVisaInfoForGrid = async (VisaData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeVisaInfoForGrid,
        payload: VisaData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} ctcData PC_TD_03.3.1 has the data to retrieve the data from the db
 * @returns the response
 */
export const getCTC = async (ctcData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getCTC,
        payload: ctcData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} StatusData PC_TD_03.4.1 has the data to retrieve the data from the db
 * @returns the response
 */

export const getStatus = async (StatusData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getStatus,
        payload: StatusData,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} GroupData PC_TD_03.5.1 has the data to retrieve the data from the db
 * @returns the response
 */

export const getGroup = async (GroupData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getGroup,
        payload: GroupData,
    };

    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} GroupData PC_P_24 has the data to retrieve the data from the db
 * @returns the response
 */
export const postEmployeeDocumentInfo = async (GroupData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postEmployeeDocumentInfo,
        payload: GroupData,
    };

    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} documentData PC_P_15 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeDocumentInfo = async (documentData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeDocumentInfo,
        payload: documentData,
    };

    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} PostImageData PC_PC_06 has the data to retrieve the data from the db
 * @returns the response
 */
export const postCoverImage = async (PostImageData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.postCoverImage,
        payload: PostImageData,
    };
    //
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} loadGridPostData PC_EIF_08 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmploymentType = async (GroupData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmploymentType,
        payload: GroupData,
    };
    //
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} GroupData PC_TD_06 has the data to retrieve the data from the db
 * @returns the response
 */
export const getEmployeeDetailsForDashboard = async (GroupData) => {
    debugger;
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmployeeDetailsForDashboard,
        payload: GroupData,
    };

    const response = await client(body);
    return response;
};

export const getPreliminaryOnboard = async (GroupData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getPremilinaryOnboard,
        payload: GroupData,
    };

    const response = await client(body);

    return response;
};

export const getOnboardSummary = async (GroupData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getOnboardSummary,
        payload: GroupData,
    };

    const response = await client(body);

    return response;
};

export const getCurrentCTC = async (GroupData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getCurrentCTC,
        payload: GroupData,
    };

    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} empData PC_ADF_27,PC_EIF_08 has the data to retrieve the data from the db
 * @returns the response
 */

export const getNotificationId = async (empData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getNotificationId,
        payload: empData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} empData PC_F_06.4 has the data to retrieve the data from the db
 * @returns the response
 */

export const getEmpReportsToAndRole = async (empData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getEmpReportsToAndRole,
        payload: empData,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} empData PC_TD_03.5.1  has the data to retrieve the data from the db
 * @returns the response
 */
export const getReportingEmpId = async (empData) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getReportingEmpId,
        payload: empData,
    };
    const response = await client(body);

    return response;
};

/*export const encrypData = async (empData) => {
  let body = {
    modulename: employeeDirectoryConstant.module.TeamDirectory,
    methodname: employeeDirectoryConstant.methodname.encrypData,
    payload: empData,
  };
  const response = await client(body);
  
  return response;
};*/

/***** Feedback module API functions *****/

/**
 *
 * @param {*} Feedbackdata PC_FG_06 has the data to retrieve the data from the db
 * @returns the response
 */

export const getEmployeeFeedbacks = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getEmployeeFeedbacks,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_F_06 has the data to retrieve the data from the db
 * @returns the response
 */

export const getIndivigualEmpFeedback = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getIndivigualEmpFeedback,
        payload: Feedbackdata,
    };
    //
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_F_06.1 has the data to retrieve the data from the db
 * @returns the response
 */
export const getFeedbackAudit = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getFeedbackAudit,
        payload: Feedbackdata,
    };
    //
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_FB_06,PC_F_06.2,PC_IFG_06.1 has the data to retrieve the data from the db
 * @returns the response
 */
export const getFlagCountAndName = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getFlagCountAndName,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_FB_06 has the data to retrieve the data from the db
 * @returns the response
 */
export const postFeedback = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.postFeedback,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_F_12,PC_EDF_08 has the data to retrieve the data from the db
 * @returns the response
 */

export const postFeedbackResponse = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.postFeedbackResponse,
        payload: Feedbackdata,
    };
    const response = await client(body);
    return response;
};

export const postHrDeny = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.postHrDeny,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_FHA_06.1 has the data to retrieve the data from the db
 * @returns the response
 */
export const getFeedbackHeaderDetails = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getFeedbackHeaderDetails,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_IFG_06 has the data to retrieve the data from the db
 * @returns the response
 */

export const getFeedbackDataSpecificFlag = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getFeedbackDataSpecificFlag,
        payload: Feedbackdata,
    };
    const response = await client(body);
    return response;
};

/**
 *
 * @param {*} Feedbackdata PC_FHA_06 has the data to retrieve the data from the db
 * @returns the reponse
 */
export const postHrApproval = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.postHrApproval,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

//////////// offboarding api //////////////////////////

//to insert the offboard data by employee
export const insertOffboardData = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.postinitiateOffboardingData,
        payload: data,
    };
    const response = await clientOff(body);

    return response;
};

//to get the offboarding hr grid
export const getOffboardingData = async (loadData) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getoffboardingGrid,
        payload: loadData,
    };
    const response = await clientOff(body);

    return response;
};

/**
 * PC_OF_12
 * @param {*} getOffboardingDataUser has the data to retrieve the data from the db
 * @returns the response
 */
export const getOffboardingDataUser = async (empdata) => {
    //
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.offboardingGriduser,
        payload: empdata,
    };
    const response = await clientOff(body);
    return response;
};

//to inisitate the transition plan
export const insertInitiateData = async (empdata) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.postinitialTransitionOffboardingData,
        payload: empdata,
    };
    const response = await clientOff(body);
    return response;
};
export const getResponsiblePersonId = async (data) => {
    // ;
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getResponsiblePersonId,
        payload: data,
    };
    const response = await clientOff(body);
    // ;
    return response;
};

//to load the task
export const loadTask = async (assignId) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getAllOffboardingTemplateTasks,
        payload: assignId,
    };
    const response = await clientOff(body);

    return response;
};

//to get the form by team
export const getOffboardDetailsById = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getOffboardingDetailsById,
        payload: data,
    };
    const response = await clientOff(body);
    return response;
};

//to get the reason drop down
export const getReasonDD = async (emp_id) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getReasonForRelieving,
        payload: { emp_id: emp_id },
    };

    const response = await clientOff(body);
    return response;
};
//Update the status
export const updateTaskStatus = async (taskdata) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.postIndividualTaskStatus,
        payload: taskdata,
    };

    const response = await clientOff(body);
    return response;
};
//to update the transition plan
export const updateTransitionPlan = async (empdata) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.updateTransitionPlan,
        payload: empdata,
    };

    const response = await clientOff(body);
    return response;
};
export const updateTemplatePlan = async (empdata) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.updateTemplatePlan,
        payload: empdata,
    };

    const response = await clientOff(body);
    return response;
};

export const directoryHR = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getdirectoryHR,
        payload: data,
    };
    const response = await clientOff(body);

    return response;
};

//to get the assign template DD
export const getAssignTemplate = async () => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getAssignTemplate,
        payload: {},
    };
    const response = await clientOff(body);
    return response;
};

//to get the template assigned
export const getTaskDetails = async (tempId) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getAllOffboardingTemplateTasks,
        payload: tempId,
    };
    const response = await clientOff(body);

    return response;
};
//to delete
export const deleteTaskDetails = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.postdeleteOffboardingData,
        payload: data,
    };
    const response = await clientOff(body);

    return response;
};

//to individual task
export const updateIndividualTask = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.postIndividualTask,
        payload: data,
    };
    const response = await clientOff(body);
    return response;
};
export const getIndividualTasks = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.getAllOffboardingTemplateTasks,
        payload: data,
    };
    const response = await clientOff(body);
    return response;
};
export const manipulateIndividualOffboardTask = async (data) => {
    let body = {
        modulename: apiIndex.modulename.OffboardingRoute,
        methodname: apiIndex.methodname.manipulateIndividualOffboardTask,
        payload: data,
    };
    const response = await clientOff(body);
    return response;
};
//
//Added method for posting bulk feedback
export const postBulkFeedback = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Feedback,
        methodname: employeeDirectoryConstant.methodname.getEmployeePrimaryInfo,
        payload: Feedbackdata,
    };
    const response = await client(body);

    return response;
};

export const getpolicyDirectoryData = async (Feedbackdata) => {
    let body = {
        modulename: employeeDirectoryConstant.module.TeamDirectory,
        methodname: employeeDirectoryConstant.methodname.getPolicyData,
        payload: Feedbackdata,
    };
    const response = await client(body);
    return response;
};

export const fetchGridDetails = async (gridActions) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Centcom,
        methodname: employeeDirectoryConstant.methodname.getEmployeeData,
        payload: gridActions,
    };
    const response = await CentcomClient(body);
    return response;
};

//
export const updateGridDetails = async (updateObj) => {
    let body = {
        modulename: employeeDirectoryConstant.module.Centcom,
        methodname: employeeDirectoryConstant.methodname.editTodo,
        payload: updateObj,
    };
    const response = await CentcomClient(body);

    return response;
};

export const fetchDropDownDetails = async () => {
    let body = {
        modulename: employeeDirectoryConstant.module.Centcom,
        methodname: employeeDirectoryConstant.methodname.getDomainSkillAndProjects,
    };
    const response = await CentcomClient(body);
    return response;
};
